var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{attrs:{"novalidate":""},on:{"submit":_vm.submit}},[_vm._t("default",null,null,{ $v: _vm.$v.form, controls: _vm.form, formData: _vm.formData })],2)
}
var staticRenderFns = []

export { render, staticRenderFns }